import React from 'react';
import Modal from 'react-modal';
import '../css/SystemIntegratorView.css';
// import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
// import createHistory from 'history/createBrowserHistory';


// Distributor view page  component


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '90%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const Styles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
  }
};

const SiRating = [
  { label: 'A++' },
  { label: 'A' },
  { label: 'B+' },
];

const SiRelationStat = [
  { label: 'Hot' },
  { label: 'Warm' },
  { label: 'Dry' },
  { label: 'Cold' },
];


export default class DistributorView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      noOfParams: [],
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      SiName: this.props.siCurrentData.si_name,
      SiEmail: this.props.siCurrentData.si_email,
      SiCompany: this.props.siCurrentData.si_company,
      SiMobile: this.props.siCurrentData.si_mobile,
      SiArea: this.props.siCurrentData.si_area,
      SiAddress: this.props.siCurrentData.si_address,
      DistributorCountry: this.props.siCurrentData.si_country ? this.props.siCurrentData.si_country : "N/A",
      SiGST: this.props.siCurrentData.si_gstin,
      errorMessage: [],

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {

    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {

  }

  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpen: false
        }, () => this.props.closeAllModal())
      }, 500);

    })
  }

  onSelectChange = (operationMode, valueSelect) => {
    if (operationMode === 'rating') {
      this.setState({
        SiRating: valueSelect.value,
        errorMessage: []
      })
    }
    if (operationMode === 'distributorCountry') {
      const isIndia = valueSelect === 'India';
      this.setState({
        DistributorCountry: valueSelect,
        showIndiaFields: isIndia,
        SiArea: isIndia ? this.state.SiArea : '',
        SiGST: isIndia ? this.state.SiGST : '',
        errorMessage: []
      });
    }
    if (operationMode === 'relationStat') {
      this.setState({
        SiRelationStat: valueSelect.value,
        errorMessage: []
      })
    }
  }

  handleChangeInputBox = (name, event) => {
    this.setState({
      [name]: event
    });
  };

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>VIEW DISTRIBUTOR</h3>
          <div className="row">
            <div className="col-6 mx-0 px-0 disableEvent">
              <InputBox
                inputText={this.state.SiName}
                error={false}
                errorText=""
                placeholder="Distributor Name:"
                inputBoxName="SiName"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                disableEvent={true}
              />
            </div>

            <div className="col-6  disableEvent"
            //  style={{paddingLeft: '0px',paddingRight: '0px', marginTop: '10px'}} 
            >
              <InputBox
                inputText={this.state.DistributorCountry}
                error={false}
                errorText=""
                placeholder="Distributor Country:"
                inputBoxName="DistributorCountry"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                disableEvent={true} />
            </div>
            {this.state.showIndiaFields && (
              <div className="col-6  disableEvent"
              //  style={{paddingLeft: '0px',paddingRight: '0px', marginTop: '10px'}} 
              >
                <InputBox
                  inputText={this.state.SiArea}
                  error={false}
                  errorText=""
                  placeholder="Distributor Area:"
                  inputBoxName="SiArea"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  disableEvent={true} />
              </div>)}
            <div className="col-6 mx-0 px-0 disableEvent">
              <InputBox
                inputText={this.state.SiAddress}
                error={false}
                errorText=""
                placeholder="Distributor Address:"
                inputBoxName="SiAddress"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                disableEvent={true} />
            </div>
            <div className="col-6  disableEvent">
              <InputBox
                inputText={this.state.SiEmail}
                error={false}
                errorText=""
                placeholder="Distributor Email:"
                inputBoxName="SiEmail"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                disableEvent={true} />
            </div>
            {this.state.showIndiaFields && (
              <div className="col-6 px-0 disableEvent" style={{ marginTop: '10px' }}
              >
                <InputBox
                  inputText={this.state.SiGST}
                  placeholder="Distributor GST:"
                  inputBoxName="SiGST"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  someText={this.state.SiGST}
                  textLength={15}
                  validate={true}
                  disableEvent={true}
                />
              </div>)}
            <div className="col-6 mx-0 px-0  disableEvent" style={{ marginTop: '10px' }} >
              <InputBox
                inputText={this.state.SiMobile}
                error={false}
                errorText=""
                placeholder="Distributor Mobile:"
                inputBoxName="SiMobile"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                disableEvent={true} />
            </div>
            <div className="col-6 disableEvent" style={{ marginTop: '10px' }}>
              <InputBox
                inputText={this.state.SiCompany}
                error={false}
                errorText=""
                placeholder="Distributor Company"
                inputBoxName="SiCompany"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                disableEvent={true} />
            </div>
          </div>

          <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
            <div className="btn btn-new-grey " onClick={this.closeModal}>Close</div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
